<template>
    <div>

        <div class="form-info">
            <div class="form-row">
                <div class="form-label">
                    <label>服务订单号：</label>
                </div>
                <div class="form-value">
                    <div class="value" :title="servcOrder.no">{{servcOrder.no}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>零售商名称：</label>
                </div>
                <div class="form-value">
                    <div class="value" :title="servcOrder.buyerComName">{{servcOrder.buyerComName}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>零售商机构名称：</label>
                </div>
                <div class="form-value">
                    <div class="value" :title="servcOrder.buyerShopName">{{servcOrder.buyerShopName}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>机构地址：</label>
                </div>
                <div class="form-value" style="width: calc(100% - 146px)">
                    <div class="value" :title="servcOrder.buyerShopAddr">{{servcOrder.buyerShopAddr}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>电话：</label>
                </div>
                <div class="form-value">
                    <div class="value" :title="servcOrder.buyerShopContactTel">{{servcOrder.buyerShopContactTel}}</div>
                </div>
            </div>
        </div>
        <el-form :model="servcOrder" class="demo-ruleForm">
            <div class="form-single">
                <div class="title required">请选择指派方</div>
                <div class="content">
                    <el-form-item prop="servicerComName">
                        <swb-org-tree :isShowIcon=false :enableSearch=true :isRadio=true :closed="false" ref="swb_org_tree"></swb-org-tree>
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import servcOrderApi from '../../api/servcOrder'

    import SwbOrgTree from '../orgStruct/OrgTree';
    Vue.regist(SwbOrgTree);

    export default {
        name: 'swb-servc-order-appoint-store',
        desc: '指派，机构',
        props: ['servcOrderId'],
        data: function () {
            return {
                servcOrder: {},
                radio: '1',
                enableSearch: null,
                buyerRegionId: null,
                selectFlag: "default",
            }
        },
        created: function () {
            let self = this;
            self.enableSearch = true;
            self.getServcOrderDetailedInfo();
        },
        methods: {
            getServcOrderDetailedInfo: function () {
                let self = this;
                let postData = {};
                postData.servcOrderId = self.servcOrderId;
                let loading = MsgBox.loading();
                servcOrderApi.getServcOrderDetailedInfo(postData, function (result) {
                    if(result.type == "info") {
                        self.servcOrder = result.data;
                        loading.close();
                    } else {
                        loading.close();
                        MsgBox.warning(result.message);
                    }
                })
            },
            /*            appointStyle: function () {
             let self = this;
             if(self.radio == 1) {//指定门店
             //选择默认门店
             self.selectFlag = "default";
             } else if(self.radio == 2) {//分公司
             self.selectFlag = "ambitus";
             }
             },*/
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                let resultTree = self.$refs.swb_org_tree.getDlgResult() || {};
                if(resultTree.type == 'info') {
                    result.type = 'info';
                    result.data = resultTree.data;
                } else {
                    result.type = "warn";
                    result.message = "没有对应的数据";
                }
                /* } else {
                 result.type = "warn";
                 result.message = "校验失败";
                 }
                 });*/
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcOrder/ServcOrderAppointStore.vue